module.exports = __webpack_public_path__ + "static/media/bb_180.5488f67f.svg";